import { UserRole } from '@hms/shared';
import { WAREHOUSE_DASHBOARD_PATH } from './warehouseRoutes';

/**
 * The landing route of each role: where login, the forced password change and a refused route send it, and what the
 * bare `/dashboard` resolves to. Each route must admit its own role, or the guard redirects it there in a loop. `hr`
 * gates no module yet (CORA-242), so it lands on the roles-free `/profile`.
 */
export const ROLE_DASHBOARDS: Record<UserRole, string> = {
  [UserRole.DOCTOR]: '/dashboard',
  [UserRole.NURSE]: '/nurse-dashboard',
  [UserRole.RECEPTIONIST]: '/reception-dashboard',
  [UserRole.PATIENT]: '/patient-portal',
  [UserRole.ADMIN]: '/management-dashboard',
  [UserRole.BILLING]: '/billing/invoices',
  [UserRole.STOCK_MANAGER]: WAREHOUSE_DASHBOARD_PATH,
  [UserRole.BIOMEDICAL]: '/equipment',
  [UserRole.HR]: '/profile',
  [UserRole.SUPER_ADMIN]: '/admin/organizations',
  [UserRole.HOSPITAL_ADMIN]: '/management-dashboard',
  [UserRole.CENTRAL_STOCK_MANAGER]: WAREHOUSE_DASHBOARD_PATH,
};
